// extracted by mini-css-extract-plugin
module.exports = {"container":"Bi","block":"Ci","subheading":"Di","cta":"Ei","disabled":"Fi","noBotMargin":"Gi","light":"Hi"};